export const DiagramNetwork = () => {
    return (
        <svg fill="currentColor" aria-hidden="true" viewBox="0 0 61 65">
            <path
                d="M41.96 8.784a2.4 2.4 0 0 1 4.14 2.426l-.06.103L29.506 37.98a2.4 2.4 0 0 1-4.14-2.426l.061-.103z"
                opacity=".5"
            />
            <path
                d="M4.457 13.666a2.4 2.4 0 0 1 3.306-.044l.088.086 21.334 21.867a2.4 2.4 0 0 1-3.348 3.438l-.088-.086L4.416 17.06a2.4 2.4 0 0 1 .041-3.393z"
                opacity=".5"
            />
            <path
                d="M25.77 35.02a2.4 2.4 0 0 1 3.479 3.304l-.085.09L7.83 59.746a2.4 2.4 0 0 1-3.479-3.305l.085-.09z"
                opacity=".5"
            />
            <path
                d="M24.97 35.833a2.4 2.4 0 0 1 3.005-1.388l.11.04 26.933 10.667a2.4 2.4 0 0 1-1.659 4.503l-.109-.04-26.933-10.667a2.4 2.4 0 0 1-1.348-3.115z"
                opacity=".5"
            />
            <circle cx="27.466" cy="36.716" r="9.333" />
            <circle cx="6.133" cy="15.383" r="6.133" />
            <circle cx="54.133" cy="47.383" r="6.133" />
            <circle cx="43.467" cy="9.517" r="9.333" />
            <circle cx="6.133" cy="58.049" r="6.133" />
        </svg>
    );
};
